"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackGTMEvent = exports.trackPageView = exports.trackConversion = exports.trackStructuredEvent = void 0;
var snowplow = __importStar(require("@snowplow/browser-tracker"));
var react_ga_1 = __importDefault(require("react-ga"));
var init_1 = require("../init");
var generated_1 = require("./generated");
__exportStar(require("./generated"), exports);
window.dataLayer = window.dataLayer || [];
var trackStructuredEvent = function (event) {
    snowplow.trackStructEvent(event);
    if ((0, init_1.trackerReady)()) {
        react_ga_1.default.event(event);
    }
};
exports.trackStructuredEvent = trackStructuredEvent;
var trackConversion = function (event) {
    var _a;
    (0, generated_1.trackInsuranceSubscribed)(event);
    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
        event: 'conversion',
        eventModel: {
            send_to: 'AW-799339966/SSkICMGBhfwBEL7rk_0C',
            event_category: 'purchase',
            event_label: event.vertical,
            event_region: event.region_of_purchase,
            event_policy_id: event.policy_id,
            event_commissions_group: event.commissions_group,
        },
    });
};
exports.trackConversion = trackConversion;
var trackPageView = function () {
    snowplow.trackPageView();
    if ((0, init_1.trackerReady)()) {
        react_ga_1.default.pageview(window.location.pathname);
    }
};
exports.trackPageView = trackPageView;
var trackGTMEvent = function (event) {
    var _a;
    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(event);
};
exports.trackGTMEvent = trackGTMEvent;
